// HotX CDN 积分状态仓库，更新时间：2026-09-02 15:06 CST。余额、统计、冻结和签到状态均来自同一后端 PointAccount 事实源。
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { pointApi, type PointSummary } from '../api/pointApi'

export const usePointStore = defineStore('points', () => {
  const summary = ref<PointSummary | null>(null)
  const unreadNotificationCount = ref(0)
  const loading = ref(false)
  const notificationsLoading = ref(false)

  async function refresh() {
    if (loading.value) return summary.value
    loading.value = true
    try {
      summary.value = await pointApi.summary()
      return summary.value
    } finally {
      loading.value = false
    }
  }

  async function refreshNotifications() {
    if (notificationsLoading.value) return unreadNotificationCount.value
    notificationsLoading.value = true
    try {
      const data = await pointApi.notifications({ page: 1, size: 1 })
      unreadNotificationCount.value = data.unreadCount || 0
      return data.unreadCount || 0
    } finally {
      notificationsLoading.value = false
    }
  }

  function clear() {
    summary.value = null
    unreadNotificationCount.value = 0
  }

  return {
    summary,
    unreadNotificationCount,
    loading,
    notificationsLoading,
    refresh,
    refreshNotifications,
    clear
  }
})
